import { Component } from 'react';
import Team from "../layouts/aboutus/Team";
import { Footer, HeaderModern, Loader, TopBar, TopHeader } from '../layouts/general';
class AboutUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headers: [
                {
                    id: 1,
                    names: 'Who We Are'
                }
            ],
            dataBanner: [
                {
                    id: 1,
                    classename01: 'flat-title-page parallax parallax7 style3',
                    classename02: 'container wrap-title-page ',
                    links: '/about-us',
                    names: 'Who We Are'
                }
            ]
        }
    }
    render() {
        return (
            <div className="bg-body3">
                <div className="boxed">
                    <Loader />
                    <TopBar />
                    <TopHeader />
                    {
                        this.state.headers.map(data => (
                            <HeaderModern data={data} key={data.id}/>
                        ))
                    }
                    <div className="page-title">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="page-title-heading">
                                        {/* <h1 className="h1-title">Data Consulting</h1> */}
                                    </div>
                                    {/* <ul className="breadcrumbs">
                                        <li><Link to="#" title="">Home<i className="fa fa-angle-right" aria-hidden="true"></i></Link></li>
                                        <li><Link to="#" title="">About<i className="fa fa-angle-right" aria-hidden="true"></i></Link></li>
                                        <li><Link to="#" title="">About Us</Link></li>
                                    </ul> */}
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Who We Are intro section */}
                    <section className="flat-row modern-page-section modern-team-intro">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="modern-intro-panel">
                                        <div className="title-section center modern-section-title modern-page-title">
                                            <h2>Our Team</h2>
                                        </div>
                                        <p>Experts in MERL, statistics, and evidence-based consulting.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <Team />

                    <Footer />
                </div>
            </div>
        );
    }
}

export default AboutUs;
